const mainField = "id";

const dataFieldConfig = [
  {
    id: "caption",
    field: "caption",
    align: "center",
    disablePadding: false,
    label: "標題",
  },
  {
    id: "thumbnail",
    field: "thumbnail",
    align: "center",
    disablePadding: false,
    label: "Cover縮圖",
  },
  {
    id: "video_url",
    field: "video_url",
    align: "center",
    disablePadding: false,
    label: "影片 URL",
  }
];

const fetchDataConfig = {
  url: "/dashboardVideo/query",
};

const tableActionConfig = [

  {
    type: "link",
    label: "Edit",
    icon: "edit",
    url: "/dashboardVideo/update/$id",
  },
  {
    type: "confirmDialog",
    label: "Delete",
    icon: "delete",
    url: "/dashboardVideo/delete/$id",
    dialogConfig: {
      title: "確定要刪除嗎？",
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonAriaLabel: "確定",
      cancelButtonAriaLabel: "取消",
      cancelButtonColor: "#a7a7a7",
      successMsg: "刪除成功",
      failMsg: "刪除失敗",
    },
  },
];

const filterConfig = [
  { type: "text", label: "按標題搜索", field: "title_zh,title_en" },
];

const TableConfig = {
  mainField,
  dataFieldConfig,
  fetchDataConfig,
  tableActionConfig,
  filterConfig,
};

export default TableConfig;
